/** User-facing message when a payment receipt PDF is not yet available. */
export function getPaymentReceiptUnavailableMessage(row) {
  const paySt = String(row?.paymentStatus || '').toUpperCase();
  const method = String(row?.paymentMethod || '').toUpperCase();
  if (paySt === 'PENDING_APPROVAL') {
    if (method === 'BANK_TRANSFER' || method === 'CHEQUE_DEPOSIT') {
      return 'Payment receipt is available after you approve the bank/cheque deposit.';
    }
    return 'Payment receipt is available after the payment has been approved.';
  }
  if (paySt === 'REJECTED') {
    return 'No payment receipt — this payment was rejected.';
  }
  if (paySt === 'UNPAID') {
    return 'Payment receipt is available after a successful payment.';
  }
  return 'Payment receipt is not available for this request yet.';
}

/**
 * Resolve payment receipt download keys for staff rows.
 * Only returns keys when a receipt snapshot exists or finance has posted a settled payment.
 * Offline/card references alone do not imply a receipt exists (e.g. hold / pending approval).
 */
export function resolveStaffPaymentReceiptKeys(row) {
  const paySt = String(row?.paymentStatus || '').toUpperCase();
  const settled = ['PAID', 'PARTIALLY_PAID'].includes(paySt);
  const keys = new Map();

  for (const pr of row?.paymentReceipts || []) {
    const key = String(pr?.paymentKey || '').trim();
    if (key && String(pr?.receiptNumber || '').trim()) {
      keys.set(key, String(pr.receiptNumber).trim());
    }
  }

  if (settled) {
    for (const fp of row?.financePosting?.payments || []) {
      const key = String(fp?.paymentKey || '').trim();
      if (key && (fp?.transactionId || fp?.docCode) && !keys.has(key)) {
        keys.set(key, String(fp.docCode || key).trim());
      }
    }
  }

  if (!keys.size && settled && row?.taxInvoice?.generatedAt) {
    return [{ paymentKey: 'latest', receiptNumber: 'Receipt' }];
  }

  return [...keys.entries()].map(([paymentKey, receiptNumber]) => ({
    paymentKey,
    receiptNumber,
  }));
}

export function canStaffDownloadPaymentReceipt(row, paymentKey) {
  const key = String(paymentKey || '').trim();
  if (!key || !row) return false;
  return resolveStaffPaymentReceiptKeys(row).some((item) => item.paymentKey === key);
}

export function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
